import { render } from "./SkuSelector.vue?vue&type=template&id=a978f12c&scoped=true"
import script from "./SkuSelector.vue?vue&type=script&lang=js"
export * from "./SkuSelector.vue?vue&type=script&lang=js"

import "./SkuSelector.vue?vue&type=style&index=0&id=a978f12c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a978f12c"]])

export default __exports__